export default "__VITE_ASSET__DDczSKhT__"